<template>
	<el-dialog
		title="添加标签"
		:visible.sync="dialogLabelvisible"
		:before-close="closeDialogLabel"
		:modal="modal"
	>
		<div class="tag">
			<span style="margin-right:10px">选择标签:</span>
			<div class="lables">
				<span
					v-for="(item,index) in lables"
					class="tags"
					:style="{background:item.label_Color}"
					@click="onSelected(item.label_Id)"
				>
					{{item.label_Name}}
					<span class="opert" v-if="item.selected==1">
						<i class="el-icon-check"></i>
					</span>
				</span>
				<div class="clear"></div>
			</div>

			<div class="clear"></div>
		</div>

		<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="onClick">确 定</el-button>
		</span>
	</el-dialog>
</template>
<script>
export default {
	name: 'selectedTag',
	data() {
		return {
			lables: [],
			selected: [],
			modal: false
		}
	},
	props: {
		dialogLabelvisible: {
			type: Boolean,
			default: false
		},
		data: {
			type: Array,
			default: () => []
		}
	},
	watch: {
		data: function(val) {
			this.lables = val
		}
	},
	methods: {
		closeDialogLabel() {
			this.$emit('LabelChangevisible', false)
		},
		onSelected(id) {
			let vm = this

			let index = vm.lables.findIndex(d => d.label_Id == id)
			if (index > -1) {
				if (vm.lables[index].selected == 0) {
					vm.lables[index].selected = 1
				} else {
					vm.lables[index].selected = 0
				}
			}
		},
		onClick() {
			this.$emit('updTag', this.selected)
			this.closeDialogLabel()
		}
	}
}
</script>
<style scoped>
.tag > span {
	float: left;
}
.tag > div.lables {
	float: left;
}
.lables .tags {
	display: inline-block;
	padding: 0 3px;
	height: 20px;
	line-height: 20px;
	font-size: 12px;
	color: #fff;
	margin: 0 10px 0 0;
	border-radius: 3px;
	position: relative;
	margin-bottom: 10px;
}
.lables .tags:hover {
	cursor: pointer;
}
.lables {
	max-width: 80%;
}
.lables span .opert {
	position: absolute;
	width: 15px;
	height: 15px;
	line-height: 15px;
	margin-left: 3px;
	border-radius: 50%;
	right: -7px;
	color: white;
	text-align: center;
	background-color: red;
	top: -9px;
}

/* .lables span.selected {
	padding: 10px 20px;
	background-color: #50a2fc;
	text-align: center;
	color: #fff;
	cursor: pointer;
	margin-left: 20px;
}
.lables span:hover {
	padding: 10px 20px;
	background-color: #50a2fc;
	text-align: center;
	color: #fff;
	cursor: pointer;
	margin-left: 20px;
}
.lables span {
	display: 55px;
	display: inline-block;
	padding: 10px 20px;
	background-color: #666;
	text-align: center;
	color: #fff;
	margin-bottom: 20px;
	cursor: pointer;
	margin-left: 20px;
	box-sizing: content-box;
} */
</style>


// WEBPACK FOOTER //
// src/components/customer/talks/selectedTag.vue